import { ISpatialReferenceRepository, SpatialReferenceEntity, ResponseValueObject } from '@gishub/domain';
import { axiosClient } from '../http/axios-client';

export class SpatialReferenceRepository implements ISpatialReferenceRepository {
  async getAll(): Promise<ResponseValueObject<SpatialReferenceEntity[]>> {
    const response = await axiosClient.get<ResponseValueObject<SpatialReferenceEntity[]>>('/printer/spatial-references');
    return response.data;
  }
}
